<ng-container *ngIf="!currentUser?.isAnon">
  <app-top></app-top>
  <div id="bodyinspinia" class="pace-done" [ngClass]="fontSizeClass">
    <div id="wrapper">
      <app-navigation></app-navigation>
      <div id="page-wrapper" class="gray-bluelight-bg" [ngClass]="pageWrapperCssClass">
        <app-app-navigation [ngClass]="topBarCssClass"></app-app-navigation>
        <app-header></app-header>
        <router-outlet>
          <ops-ng-spinner></ops-ng-spinner>
        </router-outlet>
        <app-no-print></app-no-print>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="currentUser?.isAnon">
  <div>
    <router-outlet>
      <ops-ng-spinner></ops-ng-spinner>
    </router-outlet>
  </div>
</ng-container>

